import PartnerMachines from './Partners/Machines';
import GeolocationMachines from './Geolocation/Machines';
import CmsMachines from './Cms/Machines';
import SampleMachines from './Sample/Machines';

export const UtilsMachines = {
  PartnerMachines,
  GeolocationMachines,
  CmsMachines,
  SampleMachines,
};
